// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Q1Cx","nonClickable":"styles_nonClickable__6eXNr"};